import { CoreActionTypes, CoreActionsUnion } from './core.actions';
import { createFeatureSelector, createSelector } from '@ngrx/store';

export interface CoreState {
    dateFormat: string;
    redir: string;
    loading: boolean;
}

export const initialState: CoreState = {
    dateFormat: 'MM/DD/YYYY',
    redir: '',
    loading: false
};

export function reducer(
    state: CoreState = initialState,
    action: CoreActionsUnion
): CoreState {
    switch (action.type) {
        case CoreActionTypes.SetDateFormat:
            return {
                ...state,
                dateFormat: action.payload
            };
        case CoreActionTypes.SetRedirect:
            return {
                ...state,
                redir: action.payload
            };
        default:
            return state;
    }
}

const coreState = createFeatureSelector<CoreState>('core');

export const getDateFormat = createSelector(coreState, x => x.dateFormat);
export const getRedirect = createSelector(coreState, x => x.redir);
